import { render, staticRenderFns } from "./ExamProjectExplain.vue?vue&type=template&id=4a059ef1&scoped=true"
import script from "./ExamProjectExplain.vue?vue&type=script&lang=js"
export * from "./ExamProjectExplain.vue?vue&type=script&lang=js"
import style0 from "./ExamProjectExplain.vue?vue&type=style&index=0&id=4a059ef1&prod&lang=stylus&scoped=true"
import style1 from "./ExamProjectExplain.vue?vue&type=style&index=1&id=4a059ef1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a059ef1",
  null
  
)

export default component.exports